import React, { useContext } from 'react';
import { BasePage, Helmet, StaticContext } from '@sm/webassets';
import { t, defineMessages } from '@sm/intl';
import { ThemeProvider } from 'react-jss';
import theme from '~app/styles/cmsTheme';
import BrandedSurveyClosed from '~app/pages/SurveyClosed/BrandedSurveyClosed';
import EUBrandedSurveyClosed from '~app/pages/SurveyClosed/EUBrandedSurveyClosed';
import NonBrandedSurveyClosed from '~app/pages/SurveyClosed/NonBrandedSurveyClosed';

const COPY = defineMessages({
  DEFAULT_CLOSED_MESSAGE: {
    id: 'SurveyClosedPreview.closedMessage',
    defaultMessage:
      'This survey is currently closed.  Please contact the author of this survey for further assistance.',
  },
  META_KEYWORDS: {
    id: 'SurveyClosedPreview.metaKeywords',
    defaultMessage:
      'questionnaire, questionnaires, questionaire, questionaires, free online survey, free online surveys',
  },
  CLOSED_PAGE_TITLE: {
    id: 'SurveyClosedPreview.title',
    defaultMessage: 'Free Online Survey Software by SurveyMonkey: Closed Survey',
  },
});

const SurveyClosedPreview = () => {
  const {
    pageOptions: { customClosedMessage, isNonBranded = false },
    locale,
  } = useContext(StaticContext);

  const showFooter = !isNonBranded;

  return (
    <ThemeProvider theme={theme}>
      <BasePage includeHeader={false} includeFooter={showFooter} pageId="Survey Closed" legacyWeb="anonweb">
        <Helmet>
          <base target="_top" href="/" />
          <title>{t(COPY.CLOSED_PAGE_TITLE)}</title>
          <meta name="keywords" content={t(COPY.META_KEYWORDS)} />
          <meta name="description" content={t(COPY.DEFAULT_CLOSED_MESSAGE)} />
        </Helmet>
        <Choose>
          <When condition={isNonBranded}>
            <NonBrandedSurveyClosed message={customClosedMessage} />
          </When>
          <When condition={locale.isEUSubdomain}>
            <EUBrandedSurveyClosed message={customClosedMessage} />
          </When>
          <Otherwise>
            <BrandedSurveyClosed message={customClosedMessage} />
          </Otherwise>
        </Choose>
      </BasePage>
    </ThemeProvider>
  );
};

export default SurveyClosedPreview;
